import { Box, SectionDivider } from '@domain-group/suit-theme'

import usePortalOptions from '@hooks/usePortalOptions'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import PortalOptionModule from './PortalOptionModule'

const PortalOptionsList = (props: { portalId: number }) => {
  const { portalId } = props

  const portalOptionsPayload = usePortalOptions({
    filters: {
      portal_id: portalId,
    },
    performHttpRequests: !!portalId,
    requestOptions: defaultRequestOptions.portalOption,
  })

  const {
    filteredPortalOptions,
    hasFilteredPortalOptions,
  } = portalOptionsPayload

  return (
    <Box flexDirection="column">
      {hasFilteredPortalOptions && (
        <SectionDivider boxProps={{ marginBottom: 'large' }}>PORTAL OPTIONS</SectionDivider>
      )}

      {filteredPortalOptions.map(filteredPortalOption => (
        <PortalOptionModule
          key={filteredPortalOption.id}
          portalOption={filteredPortalOption}
        />
      ))}
    </Box>
  )
}

export default PortalOptionsList
